import React from 'react';
import PropTypes from 'prop-types';

import { Popover } from 'components/legacy/Popover';
import { StarRating } from 'components/review/StarRating';

import './ReviewExcerptPopover.scss';

export default function ReviewExcerptPopover({
	position,
	review,
	showing,
	title,
}) {
	return (
		<Popover
			position={position}
			showing={showing}
			title={title}
			className="review-excerpt-popover"
		>
			<div className="facility-review-popover">
				<div className="details">
					<div className="nickname">{review.nickname}</div>
					<StarRating rating={review.rating} />
				</div>
				<div className="message">{review.message}</div>
			</div>
		</Popover>
	);
}

ReviewExcerptPopover.propTypes = {
	position: PropTypes.oneOf(['top', 'bottom']),
	showing: PropTypes.bool,
	review: PropTypes.shape({
		nickname: PropTypes.string,
		rating: PropTypes.number.isRequired,
		message: PropTypes.string.isRequired,
	}).isRequired,
	title: PropTypes.string,
};
